import { ChangeDetectorRef, Component } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from './common/components/base-component';
import { SettingsService } from './common/services/settings.service';
import { ErrorHandlerService } from './common/services/error-handler.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [DatePipe, DecimalPipe],
    imports: [RouterOutlet]
})
export class AppComponent extends BaseComponent {
    title = 'susoft-events';

    constructor(protected cdk: ChangeDetectorRef,
                public errorHandlerService: ErrorHandlerService,
                private settingService: SettingsService,
    ) {
        super(cdk, errorHandlerService);

        this.addSubscription(
            this.settingService.loadGeneralSettings().subscribe()
        );
    }
}
